import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class CampaignJobService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.CAMPAIGN_JOB = '/api/campaign-job';

        this.GET_BY_ID = '/get/{id}';
    }

    async getById(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.CAMPAIGN_JOB + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try{
            const campaign = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return campaign;
        } catch(err) {
            console.log(err);
        }
    }
}

export default CampaignJobService;